import { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { type ITableConfig } from 'shared/ui'
import { AudioPlayer, type IHandleTrackOrganizationActivity } from 'shared/ui/AudioPlayer'
import { type CallHistory } from 'entities/CallHistory/model/CallHistory'
import { useEntitiesContext } from 'entities/EntitiesExport'
import { type ICallHistoryCall } from 'entities/CallHistory/api/types'
import styles from 'pages/conversations/pages/calls/ui/CallHistoryTable/ui/styles.module.scss'
import { type CallHistoryStore } from 'pages/conversations/pages/calls/ui/CallHistory'

type ICellAudioProps = {
  url: string
  isUnread: boolean
  callItem: CallHistory
  callHistoryStore: CallHistoryStore
  tableConfig?: ITableConfig
}

export const CellAudio: FC<ICellAudioProps> = observer(
  ({ url, isUnread, callItem, tableConfig, callHistoryStore }) => {
    const {
      organizationStore: { isHipaaCompliant, handleTrackOrganizationActivity },
    } = useEntitiesContext()

    const handlePlaying = (info: boolean) => {
      if (isUnread && info) {
        callHistoryStore.callHistoryTableStore.markAsRead(callItem)
      }
    }

    return (
      <CellAudioUi
        url={url}
        handlePlaying={handlePlaying}
        handleTrackOrganizationActivity={handleTrackOrganizationActivity}
        isHipaaCompliant={isHipaaCompliant}
        record={callItem.call}
        tableConfig={tableConfig}
      />
    )
  }
)

export const CellAudioUi = ({
  url,
  tableConfig,
  handlePlaying,
  record,
  handleTrackOrganizationActivity,
  isHipaaCompliant,
}: {
  url: ICellAudioProps['url']
  tableConfig?: ICellAudioProps['tableConfig']
  handlePlaying?: (value: boolean) => void
  record_id?: string | null
  handleTrackOrganizationActivity?: (data: IHandleTrackOrganizationActivity) => void
  isHipaaCompliant?: boolean
  record?: ICallHistoryCall
}) => (
  <div
    className={styles.audioWrap}
    onClick={(e) => e.stopPropagation()}
    onKeyDown={(e) => e.stopPropagation()}
    role='presentation'
  >
    <div className={styles.audio}>
      <AudioPlayer
        url={url}
        widthWave={120}
        heightWave={16}
        size={'small'}
        colorType={tableConfig?.isHover ? 'white' : 'gray'}
        isClosed
        fromCallsHistory
        isCallAudio
        handlePlaying={handlePlaying}
        record={{ id: record?.id || 0, record_id: record?.record_id || '', sid: '' }}
        handleTrackOrganizationActivity={handleTrackOrganizationActivity}
        isHipaaCompliant={isHipaaCompliant}
      />
    </div>
  </div>
)
